export default __webpack_public_path__ + "static/media/lb-evo.4a3420a6.webp";